import { isbot } from 'isbot';
import { postImpression } from 'service/zbozi/resource';

let postImpressTimeout: null | NodeJS.Timeout = null;
const impressionsBatch = new Map<string, string[]>();

function _postImpression() {
	for (const [impressionControl, impression] of impressionsBatch) {
		try {
			postImpression({
				impression,
				impression_control: impressionControl,
			});
		} catch (error) {
			const { message } = error as Error;
			globalThis.window.DOT?.hit('error', {
				d: {
					type: 'server',
					message: message
						? `Server error - unpacked impression: ${message}`
						: 'Server error - unpacked impression',
				},
			});
		}
	}

	impressionsBatch.clear();
}

export function impress(impressionControl: string, impression: string) {
	if (isbot(navigator.userAgent)) {
		return;
	}

	if (postImpressTimeout) {
		clearTimeout(postImpressTimeout);
	}

	const impressionsPerControl = impressionsBatch.get(impressionControl);
	impressionsBatch.set(impressionControl, [...(impressionsPerControl || []), impression]);

	postImpressTimeout = setTimeout(_postImpression, 500);
}
